export default {
	namespaced: true,

	state: {},

	actions: {
		fetchFunds({ rootState }) {
			return window.axios
				.get(
					`center/${rootState.login.activeUser.centerId}/students/${rootState.login.activeUser.userName}/student-funds`,
				)
				.then((res) => {
					return res.data;
				});
		},
	},
};
